import Prism from 'prismjs';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-rust';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-docker';
import 'prismjs/components/prism-markdown';
import 'prismjs/components/prism-diff';
import 'prismjs/components/prism-hcl';

const LANGUAGE_PATTERNS: [RegExp, string][] = [
  [/^\s*(import|export|from|const|let|var|function|class|interface|type)\b/, 'typescript'],
  [/^\s*(def |class |import |from |if __name__|print\()/, 'python'],
  [/^\s*(package |import |public class |public static void)/, 'java'],
  [/^\s*(func |package |import \(|fmt\.)/, 'go'],
  [/^\s*(fn |let mut |use |impl |pub |struct |enum )/, 'rust'],
  [/^\s*(#include|int main|void |printf|sizeof)/, 'c'],
  [/^\s*(using namespace|std::|cout|cin|template)/, 'cpp'],
  [/^\s*(using |namespace |public |private |protected |class.*{)/, 'csharp'],
  [/^\s*(require |puts |def |end$|class.*<)/, 'ruby'],
  [/^\s*(<\?php|namespace |use |public function)/, 'php'],
  [/^\s*(SELECT|INSERT|UPDATE|DELETE|CREATE TABLE|ALTER TABLE|FROM|WHERE|JOIN)\b/i, 'sql'],
  [/^\s*(FROM |RUN |CMD |COPY |EXPOSE |WORKDIR |ENV |ARG |ENTRYPOINT )/i, 'docker'],
  [/^\s*[\-\*] |^#{1,6} |^\[.*\]\(|^```/, 'markdown'],
  [/^\s*<[a-z!][^>]*>/i, 'markup'],
  [/^\s*\{[\s\S]*"[^"]+"\s*:/, 'json'],
  [/^\s*[a-z_]+\s*:\s/i, 'yaml'],
  [/^\s*(resource |variable |output |data |module |provider |terraform )/, 'hcl'],
  [/^\s*([\w-]+\s*\{|@media|@import|\.[\w-]+\s*\{|#[\w-]+\s*\{)/, 'css'],
  [/^\s*(#!\/bin\/(ba)?sh|export |echo |if \[|fi$|done$)/, 'bash'],
];

export function detectLanguage(content: string): string {
  const lines = content.split('\n').slice(0, 30);
  const scores: Record<string, number> = {};
  
  for (const line of lines) {
    for (const [pattern, lang] of LANGUAGE_PATTERNS) {
      if (pattern.test(line)) {
        scores[lang] = (scores[lang] || 0) + 1;
      }
    }
  }
  
  let best = 'plain';
  let bestScore = 0;
  for (const [lang, score] of Object.entries(scores)) {
    if (score > bestScore) {
      best = lang;
      bestScore = score;
    }
  }
  
  return bestScore >= 2 ? best : 'plain';
}

export function highlightLine(line: string, language: string): string {
  if (language === 'plain' || !Prism.languages[language]) {
    return escapeHtml(line);
  }
  return Prism.highlight(line, Prism.languages[language], language);
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
